import logger from 'logger';

function isSpaModule(module, initData) {
    const { discoverEnabled, isSinglePageApp } = initData;
    switch (module) {
        case 'start-page':
        case 'brand':
        case 'brand-list':
        case 'category-list':
        case 'endless-recommendation':
        case 'favourite-sellers':
        case 'landing':
        case 'report-item':
        case 'verify-bankid':
            return true;

        case 'category':
        case 'custom-results':
        case 'search-results':
            return discoverEnabled;

        default:
            return isSinglePageApp;
    }
}

async function loadSpaModule(initData) {
    const module = await import(
        /* webpackChunkName: "tradera" */ '../../../../frontend/apps/tradera/'
    );
    return module.default(initData);
}

async function loadModule(module) {
    switch (module) {
        // Fallback modules for when SPA is toggled off
        // TODO: Remove when fully incorporated in SPA
        case 'start-page':
        case 'brand':
        case 'brand-list':
        case 'category-list':
        case 'landing':
        case 'order-checkout':
        case 'verify-bankid':
        case 'cart':
            return await import(
                /* webpackChunkName: "tradera" */ '../../../../frontend/apps/tradera/'
            );

        // Non-SPA modules
        case 'basic':
            return await import(
                /* webpackChunkName: "basic" */ '../app/pages/basic'
            );
        case 'bidding':
            return await import(
                /* webpackChunkName: "bidding" */ '../app/pages/bidding'
            );
        case 'bin-form':
            return await import(
                /* webpackChunkName: "bin-form" */ '../app/pages/bin-form'
            );
        case 'cart-checkout':
            return await import(
                /* webpackChunkName: "cart-checkout" */ '../app/pages/cart-checkout'
            );
        case 'cart-overview':
            return await import(
                /* webpackChunkName: "cart-overview" */ '../app/pages/cart-overview'
            );
        case 'category':
            return await import(
                /* webpackChunkName: "category-results" */ '../app/pages/category'
            );
        case 'checkout-select-payment':
            return await import(
                /* webpackChunkName: "checkout-select-payment" */ '../app/pages/checkout-select-payment'
            );
        case 'checkout2':
            return await import(
                /* webpackChunkName: "checkout2" */ '../app/pages/checkout2'
            );
        case 'detailed-search':
            return await import(
                /* webpackChunkName: "detailed-search" */ '../app/pages/detailed-search'
            );
        case 'endless-recommendation':
            return await import(
                /* webpackChunkName: "endless-recommendation" */ '../app/pages/endless-recommendation'
            );
        case 'image-search':
            return await import(
                /* webpackChunkName: "image-search" */ 'tradera-apps/image-search'
            );
        case 'messages':
            return await import(
                /* webpackChunkName: "messages" */ '../app/pages/messages'
            );
        case 'messaging':
            return await import(
                /* webpackChunkName: "messaging-iframe" */ '../app/pages/messaging'
            );
        case 'profile':
            return await import(
                /* webpackChunkName: "profile" */ '../app/pages/profile'
            );
        case 'search-results':
            return await import(
                /* webpackChunkName: "search-results" */ '../app/pages/search-results'
            );

        default:
            return await import(
                /* webpackChunkName: "basic" */ '../app/pages/basic'
            );
    }
}

function runModule(module, initData = {}) {
    if (!module.default) {
        //eslint-disable-next-line
        console.error(`Cannot run module "${module}" without exported default`);
    }
    return module.default(initData);
}

const handleModuleError = error => logger(error);

export { isSpaModule, loadSpaModule, loadModule, runModule, handleModuleError };
